import { SUPPORT } from '../../Actions/Support/types';

export const initialState = {
  isLoading: false,
  faqList: [],
  list:[],
  qaList:[],
  faqError: null,
  ipError: null,
  getCountriesError: null,
  productUpdateList:[],
  productUpdateListValue:[],
  countries:[],
  countryList:[],
  fieldValue: {},
  downloadModal: false,
  downloadError: null,
  downloadInitializing: false,
  downloadStarted: false,
  downloadUrl: null
}

const supportReducer = (state = initialState, action) => { //NOSONAR
  switch (action.type) {
    case SUPPORT.LOAD_SUPPORT_FAQS: {
      return {
        ...state,
        isLoading: true
      }
    }
    case SUPPORT.LOAD_SUPPORT_FAQS_SUCCESS: {
      let { list } = action;
      return {
        ...state,
        list,
        isLoading: false
      }
    }
    case SUPPORT.LOAD_SUPPORT_FAQS_FAILURE: {
      let { error } = action;
      return {
        ...state,
        faqError: error,
        isLoading: false
      }
    }

    case SUPPORT.LOAD_UNAUTHENTICATED_SUPPORT_FAQS: {
      return {
        ...state,
      }
    }
    case SUPPORT.LOAD_UNAUTHENTICATED_SUPPORT_FAQS_SUCCESS: {
      let { list } = action;
      return {
        ...state,
        list,
        currentCountry : localStorage.getItem("activeCountry"),
        isLoading: false
      }
    }
    case SUPPORT.LOAD_UNAUTHENTICATED_SUPPORT_FAQS_FAILURE: {
      let { error } = action;
      return {
        ...state,
        faqError: error,
      }
    }

    case SUPPORT.LOAD_GEO_IP_COUNTRY: {
      return {
        ...state,
        isLoading: true,
      }
    }
    case SUPPORT.LOAD_GEO_IP_COUNTRY_SUCCESS: {
      let { list } = action;
      return {
        ...state,
        countries:list,
        isLoading: false
      }
    }
    case SUPPORT.LOAD_GEO_IP_COUNTRY_FAILURE: {
      let { error } = action;
      return {
        ...state,
        ipError: error,
        isLoading: false
      }
    }

    case SUPPORT.LOAD_GET_COUNTRIES: {
      return {
        isLoading: true,
        ...state, 
      }
    }
    case SUPPORT.LOAD_GET_COUNTRIES_SUCCESS: {
      let { list } = action;
      let countryCodeList =[];
      let newList =[];     
      newList = JSON.parse(JSON.stringify(list));
      newList.sort((a, b) => a.countryName > b.countryName ? 1 : -1);
      newList.filter(element => {
        const isDuplicate = countryCodeList.includes(element.countryCode);
        if (!isDuplicate) {
          countryCodeList.push(element.countryCode);
          return true;
        }
        element.countryName = element.countryName +' ('+ element.languageName+')';
        return false;
      });
      newList.sort((a, b) => a.countryName > b.countryName ? 1 : -1);
      return {
        ...state,
        countryList : newList,
        isLoading: false
      }
    }
    case SUPPORT.LOAD_GET_COUNTRIES_FAILURE: {
      let { error } = action;
      return {
        ...state,
        getCountriesError: error,
        isLoading: false
      }
    }

    case SUPPORT.LOAD_PRODUCT_UPDATE: { //NOSONAR
      return {
        ...state,
        isLoading: true
      }
    }
    case SUPPORT.LOAD_PRODUCT_UPDATE_SUCCESS: {
      let { list } = action;
      return {
        ...state,
        productUpdateList: list,
        productUpdateListValue:list,
        list,
        fieldValue: {...state.fieldValue,
        version: list[0].title},
        isLoading: false
      }
    }
    case SUPPORT.LOAD_PRODUCT_UPDATE_FAILURE: {
      let { error } = action;
      return {
        ...state,
        productUpdateError: error,
        isLoading: false
      }
    }
    case SUPPORT.LOAD_DOWNLOAD_MODAL: {
      let { stage } = action;
      return {
        ...state,
        ...stage
      }
    }
    case SUPPORT.LOAD_DOWNLOAD_URL: {
      let { url } = action;
      return {
        ...state,
        downloadUrl: url
      }
    }

    default:
      return state
  }
}

export default supportReducer;